<template>
  <PostShowSkeleton :class="postShowClasses" v-if="false" />
  <div :class="postShowClasses" v-if="postCache" :style="postShowStyles">
    <PostShowMedia :post="postCache" />
    <div class="section meta actions" v-if="false">
      <PostShowFileMeta :post="post" v-if="false" />
      <PostShowActions :post="post" />
    </div>
    <PostShowHeader :post="postCache" @click="onClickPostHeader" />
    <PostShowContent :post="post" v-if="false" />
    <PostShowTags v-if="postCache.tags" :tags="postCache.tags" />
    <PostShowEdit :post="postCache" v-if="showPostEdit" />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { defineComponent } from 'vue';
import PostShowMedia from './components/post-show-media';
import { getStorage, socket } from '@/app/app.service';
import PostShowHeader from './components/post-show-header';
import PostShowContent from './components/post-show-content';
import PostShowActions from './components/post-show-actions';
import PostShowFileMeta from './components/post-show-file-meta';
import PostShowTags from './components/post-show-tags';
import PostShowSkeleton from './components/post-show-skeleton';
import PostShowEdit from '@/post/show/components/post-show-edit';

export default defineComponent({
  title() {
    if (this.showPost) {
      return this.postCache.title;
    } else {
      return '加载中...';
    }
  },

  props: {
    postId: String,
  },

  data() {
    return {
      showPostEdit: false,
      postCache: null,
    };
  },

  async created() {
    await this.getPostById(this.postId);

    // 布局
    const layout = getStorage('post-show-layout');

    if (layout) {
      this.setLayout(layout);
    }

    if (window) {
      window.addEventListener('keyup', this.onKeyUpWindow);
    }

    socket.on('userLikePostCreated', this.onUserLikePostCreated);
    socket.on('userLikePostDeleted', this.onUserLikePostDeleted);
    socket.on('commentCreated', this.onCommentCreated);
    socket.on('commentDeleted', this.onCommentDeleted);

    // 边栏侧板
    this.setSideSheetComponent('SeriesSideSheet');
    this.setSideSheetProps({
      post: this.post,
    });

    // 加载播放列表
    this.loadPlayList();
  },

  watch: {
    postId() {
      this.setSideSheetProps({
        post: this.post,
      });

      const plyrStore = getStorage('plyr');

      if (plyrStore && plyrStore.speed && window.player) {
        window.player.speed = plyrStore.speed;
      }
    },

    post(newValue) {
      if (newValue) {
        // 解决闪动问题
        this.postCache = newValue;
      }
    },
  },

  unmounted() {
    if (window) {
      window.removeEventListener('keyup', this.onKeyUpWindow);
    }

    socket.off('userLikePostCreated', this.onUserLikePostCreated);
    socket.off('userLikePostDeleted', this.onUserLikePostDeleted);
    socket.off('commentCreated', this.onCommentCreated);
    socket.off('commentDeleted', this.onCommentDeleted);

    // 关闭侧板
    if (this.isSideSheetActive) {
      this.closeSideSheet();
    }
  },

  computed: {
    ...mapGetters({
      loading: 'post/show/loading',
      post: 'post/show/post',
      layout: 'post/show/layout',
      sideSheetComponent: 'layout/sideSheetComponent',
      posts: 'post/index/posts',
      isSideSheetActive: 'layout/isSideSheetActive',
    }),

    showPost() {
      return !this.loading && this.postCache;
    },

    postShowClasses() {
      return ['post-show', this.layout];
    },

    postShowStyles() {
      if (this.post && this.post.series && this.post.series.color) {
        return {
          '--plyr-range-fill-background': this.postCache.series.color,
        };
      }
      return {};
    },
  },

  methods: {
    ...mapActions({
      getPostById: 'post/show/getPostById',
      loadPlayList: 'post/show/loadPlayList',
      closeSideSheet: 'layout/closeSideSheet',
    }),

    ...mapMutations({
      setLayout: 'post/show/setLayout',
      setPostTotalLikes: 'post/show/setPostTotalLikes',
      setPostTotalComments: 'post/show/setPostTotalComments',
      setSideSheetComponent: 'layout/setSideSheetComponent',
      setSideSheetProps: 'layout/setSideSheetProps',
    }),

    onClickPostShowMedia() {
      this.setLayout(`${this.layout ? '' : 'flow'}`);
    },

    onKeyUpWindow(event) {
      if (event.ctrlKey || event.metaKey) return;

      switch (event.key) {
        case 'b':
          if (this.posts && this.posts.length) {
            this.$router.back();
          }
          break;
      }
    },

    onClickPostHeader() {
      this.showPostEdit = !this.showPostEdit;
    },

    onUserLikePostCreated({ postId, socketId }) {
      if (socket.id === socketId) return;

      this.setPostTotalLikes({
        postId,
        actionType: 'increase',
      });
    },

    onUserLikePostDeleted({ postId, socketId }) {
      if (socket.id === socketId) return;

      this.setPostTotalLikes({
        postId,
        actionType: 'decrease',
      });
    },

    onCommentCreated({ comment }) {
      this.setPostTotalComments({
        postId: comment.post.id,
        actionType: 'increase',
      });
    },

    onCommentDeleted({ comment }) {
      this.setPostTotalComments({
        postId: comment.post.id,
        actionType: 'decrease',
      });
    },
  },

  components: {
    PostShowEdit,
    PostShowMedia,
    PostShowHeader,
    PostShowContent,
    PostShowActions,
    PostShowFileMeta,
    PostShowTags,
    PostShowSkeleton,
  },
});
</script>

<style scoped>
@import './styles/post-show.css';
</style>
